import { useEffect, useState } from "react";
import { addProduct, getCategories } from "../services/api";

export default function CreateProduct() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    price: "",
    image: [""],
    categoryId: "",
    description: "",
    featured: false,
    slug: "",
    qty: "",
    dimensions: "",
    sku: "",
  });

  // Load categories for dropdown
  useEffect(() => {
    getCategories().then(setCategories).catch(console.error);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const updateImage = (index, value) => {
    const image = [...form.image];
    image[index] = value;
    setForm({ ...form, image });
  };

  const addImage = () => {
    setForm({ ...form, image: [...form.image, ""] });
  };

  const removeImage = (index) => {
    const updatedImages = form.image.filter((_, i) => i !== index);
    setForm({ ...form, image: updatedImages });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addProduct({
        ...form,
        price: Number(form.price),
        qty: Number(form.qty),
        image: form.image.filter(Boolean), // remove empty
      });

      alert("Product created successfully ✅");

      setForm({
        name: "",
        slug: "",
        price: "",
        image: [""],
        categoryId: "",
        description: "",
        featured: false,
        qty: "",
        dimensions: "",
        sku: "",
      });
    } catch (err) {
      console.error(err);
      alert("Failed to create product ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="text-3xl font-serif text-light_primary mb-6">
        Create Product
      </h1>

      <form
        onSubmit={handleSubmit}
        className="bg-gray-900 p-6 rounded-xl space-y-4"
      >
        {/* Title */}
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="Product Name"
          required
          className="w-full p-3 rounded bg-gray-800 text-white"
        />

        <input
          name="sku"
          value={form.sku}
          onChange={handleChange}
          placeholder="SKU"
          className="w-full p-3 rounded bg-gray-800 text-white"
        />

        {/* Price */}
        <input
          name="price"
          type="number"
          value={form.price}
          onChange={handleChange}
          placeholder="Price"
          required
          className="w-full p-3 rounded bg-gray-800 text-white"
        />

        <input
          name="qty"
          type="number"
          value={form.qty}
          onChange={handleChange}
          placeholder="Quantity"
          required
          className="p-3 rounded bg-gray-800 text-white"
        />

        <input
          name="dimensions"
          value={form.dimensions}
          onChange={handleChange}
          placeholder="Dimensions (L x W x H)"
          className="w-full p-3 rounded bg-gray-800 text-white"
        />

        {/* Image URLs */}
        <div className="space-y-2">
          <p className="text-gray-300 font-medium">Image URLs</p>

          {form.image.map((url, i) => (
            <div key={i} className="flex gap-2">
              <input
                value={url}
                onChange={(e) => updateImage(i, e.target.value)}
                placeholder={`Image URL ${i + 1}`}
                className="flex-1 p-3 rounded bg-gray-800 text-white"
              />

              {form.image.length > 1 && (
                <button
                  type="button"
                  onClick={() => removeImage(i)}
                  className="px-3 rounded bg-red-600 text-white"
                >
                  ✕
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            onClick={addImage}
            className="text-primary text-sm underline"
          >
            + Add another image
          </button>
        </div>

        {/* Category dropdown */}
        <select
          name="categoryId"
          value={form.categoryId}
          onChange={handleChange}
          required
          className="w-full p-3 rounded bg-gray-800 text-white"
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat._id} value={cat._id}>
              {cat.name}
            </option>
          ))}
        </select>

        {/* Description */}
        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Description"
          rows={4}
          className="w-full p-3 rounded bg-gray-800 text-white"
        />

        {/* Featured */}
        <label className="flex items-center gap-2 text-gray-200">
          <input
            type="checkbox"
            name="featured"
            checked={form.featured}
            onChange={handleChange}
          />
          Featured Product
        </label>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-primary text-white py-3 rounded-lg hover:opacity-90 transition"
        >
          {loading ? "Creating..." : "Create Product"}
        </button>
      </form>
    </div>
  );
}
